import { render, staticRenderFns } from "./info-form.vue?vue&type=template&id=d4f9f4ea&scoped=true&"
import script from "./info-form.vue?vue&type=script&lang=js&"
export * from "./info-form.vue?vue&type=script&lang=js&"
import style0 from "./info-form.vue?vue&type=style&index=0&id=d4f9f4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f9f4ea",
  null
  
)

export default component.exports